import { Link } from 'react-router-dom';
import { brand } from '../../config/brand';

export function SiteFooter() {
  return (
    <footer className="site-footer">
      <p>
        <span>Archivo temporal</span>
        {brand.archiveName} · {brand.authorName}
      </p>
      <nav aria-label="Enlaces legales">
        <Link to="/privacidad">Privacidad</Link>
        <Link to="/terminos">Términos</Link>
      </nav>
    </footer>
  );
}
